import { render, staticRenderFns } from "./BaseDialogButton.vue?vue&type=template&id=367973eb&"
import script from "./BaseDialogButton.vue?vue&type=script&lang=ts&"
export * from "./BaseDialogButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports